/* eslint-disable */
export default {
  _bonus_round_complete: 'bonus-round-complete',
  _bubbles: 'bubbles',
  _cartoon_pop: 'cartoon_pop',
  _chest: 'chest',
  _click: 'click',
  _correct: 'correct',
  _dance: 'dance',
  _incorrect: 'incorrect',
  _jingle: 'jingle',
  _number_bounce: 'number-bounce',
  _number_off_screen: 'number-off-screen',
  _Pop_1: 'Pop 1',
  _Pop_10: 'Pop 10',
  _Pop_2: 'Pop 2',
  _Pop_3: 'Pop 3',
  _Pop_4: 'Pop 4',
  _Pop_5: 'Pop 5',
  _Pop_6: 'Pop 6',
  _Pop_7: 'Pop 7',
  _Pop_8: 'Pop 8',
  _Pop_9: 'Pop 9',
  _shark: 'shark',
}